<template>
    <secition-card
        title="채용공고"
        v-bind="{
            loading,
        }"
    >
        <v-data-table
            v-bind="{
                headers,
                items,
                'items-per-page': -1,
                'mobile-breakpoint': -1,
            }"
            hide-default-footer
            hide-default-header
            disable-filtering
            disable-pagination
            disable-sort
            dense
        >
            <template v-for="header in headers.filter((header) => header.hasOwnProperty('formatter'))" #[`item.${header.value}`]="{ value, item }"> {{ header.formatter(value, item) }} </template>
        </v-data-table>
    </secition-card>
</template>

<script>
import api from "@/api";

import SecitionCard from "@/components/console/dumb/secition-card.vue";
import { RECRUITMENT_STATES } from "@/assets/variables";

export default {
    components: {
        SecitionCard,
    },
    props: {
        searchDateValue: { type: Array, default: () => [null, null] },
    },
    data: () => ({
        summary: {
            ON_GOING: 0,
            FINISHED: 0,
            NO_SHOWN: 0,
            CANCELED: 0,
            avgSpans: { days: 0 },
        },

        loading: false,
    }),
    computed: {
        headers() {
            return [
                {
                    text: "분류",
                    value: "_id",
                    formatter: (value) => value || "-",
                },
                {
                    text: "수량",
                    value: "count",
                    align: "end",
                    formatter: (value, item) => `${value?.format?.() || "-"}${item.suffix ?? "건"}`,
                },
            ].map((item) => ({ ...item, cellClass: `${item.cellClass || ""} text-caption` }));
        },
        items() {
            return [
                {
                    _id: "전체",
                    count: this.summary.ON_GOING + this.summary.FINISHED + this.summary.NO_SHOWN + this.summary.CANCELED,
                },
                {
                    _id: "모집중",
                    count: this.summary.ON_GOING,
                },
                {
                    _id: "모집완료",
                    count: this.summary.FINISHED,
                },
                {
                    _id: "미노출",
                    count: this.summary.NO_SHOWN,
                },
                {
                    _id: "취소",
                    count: this.summary.CANCELED,
                },
                {
                    _id: "평균 접수기간",
                    count: this.summary.avgSpans.days,
                    suffix: "일",
                },
            ];
        },
    },
    methods: {
        async search() {
            if (this.loading) return;
            else this.loading = true;

            try {
                const { searchDateValue } = this;

                const {
                    summary: { totalCount: recruitments },
                } = await api.console.recruitments.gets({
                    headers: { mode: "count-only" },
                    params: {
                        searchDateValue,
                        state: JSON.stringify({ $nin: [RECRUITMENT_STATES.NO_SHOWN.value, RECRUITMENT_STATES.CANCELED.value] }),
                    },
                });
                this.summary.recruitments = recruitments;

                const {
                    summary: { totalCount: ON_GOING },
                } = await api.console.recruitments.gets({
                    headers: { mode: "count-only" },
                    params: {
                        searchDateValue,
                        state: RECRUITMENT_STATES.ON_GOING.value,
                    },
                });
                this.summary.ON_GOING = ON_GOING;

                const {
                    summary: { totalCount: FINISHED },
                } = await api.console.recruitments.gets({
                    headers: { mode: "count-only" },
                    params: {
                        searchDateValue,
                        state: RECRUITMENT_STATES.FINISHED.value,
                    },
                });
                this.summary.FINISHED = FINISHED;

                const {
                    summary: { totalCount: NO_SHOWN },
                } = await api.console.recruitments.gets({
                    headers: { mode: "count-only" },
                    params: {
                        searchDateValue,
                        state: RECRUITMENT_STATES.NO_SHOWN.value,
                    },
                });
                this.summary.NO_SHOWN = NO_SHOWN;

                const {
                    summary: { totalCount: CANCELED },
                } = await api.console.recruitments.gets({
                    headers: { mode: "count-only" },
                    params: {
                        searchDateValue,
                        state: RECRUITMENT_STATES.CANCELED.value,
                    },
                });
                this.summary.CANCELED = CANCELED;

                const { span: avgSpans } = await api.console.recruitments.gets({
                    headers: { mode: "average-application-span" },
                    params: {
                        searchDateValue,
                    },
                });
                this.summary.avgSpans = avgSpans;
            } finally {
                this.loading = false;
                this.$emit("updated");
            }
        },
    },
    watch: {
        searchDateValue() {
            this.search();
        },
    },
    mounted() {
        this.search();
    },
};
</script>

<style>
</style>